import { date, object } from 'yup';
import dayjs from 'dayjs';

import { getDateWithProperTimeOffset } from '@/utils/date.utils';
import { DATE_BEFORE_TOMORROW, REQUIRED_FIELD } from '@/config/text.const';

const tomorrowWithTimeOffset = dayjs(getDateWithProperTimeOffset(new Date())).add(1, 'day').startOf('day');

export const validationSchema = object().shape({
  effectiveDate: date()
    .typeError(REQUIRED_FIELD)
    .required()
    .min(tomorrowWithTimeOffset, DATE_BEFORE_TOMORROW),
});
